

   
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  
  document.addEventListener('DOMContentLoaded', function () {
    initializeAccordion();
    updateContentMinHeight();
   
    //ensureVideoLoopOnMobile();
    document.querySelectorAll('.custom_column .product__accordion').forEach(accordion => {
        accordion.addEventListener('click', function() {
            const targetId = this.getAttribute('data-target');
            toggleAccordion(targetId);
            updateHighlighterPosition(this);
            updateActiveState(this);
        });
    });

    function initializeAccordion() {
      
        const accordions = document.querySelectorAll('.custom_column .accordion__content');
        const firstAccordion = document.querySelector('.custom_column .product__accordion');
        accordions.forEach(content => content.style.display = 'none');
        if (firstAccordion) {
            const firstContentId = firstAccordion.getAttribute('data-target');
            document.getElementById(firstContentId).style.display = 'block';
            updateHighlighterPosition(firstAccordion); // Initialize highlighter position
            updateActiveState(firstAccordion); // Initialize active state
        }
    }

    function toggleAccordion(targetId) {
        document.querySelectorAll('.custom_column .accordion__content').forEach(content => {
            content.style.display = 'none';
        });
        const selectedContent = document.getElementById(targetId);
        if (selectedContent) {
            selectedContent.style.display = 'block';
        }
    }

    function updateHighlighterPosition(accordion) {
        const highlighter = document.querySelector('.tab-highlighter');
        const accordionRect = accordion.getBoundingClientRect();
        const highlighterParentRect = highlighter.parentNode.getBoundingClientRect();
        gsap.to(highlighter, {
            x: accordionRect.left - highlighterParentRect.left,
            width: accordionRect.width,
            duration: 0.3,
            ease: 'power1.out'
        });
    }

    function updateActiveState(activeAccordion) {
        document.querySelectorAll('.custom_column .product__accordion').forEach(accordion => {
            accordion.classList.remove('active');
        });
        activeAccordion.classList.add('active');
    }

    document.querySelectorAll('.video-section-media video').forEach(video => {
      video.loop = true; // Ensure video loops

      ScrollTrigger.create({
        trigger: video,
        start: "top 50%", // Start when the top of the video is halfway through the viewport
        end: "bottom 50%", // End when the bottom of the video is halfway through the viewport
        onEnter: () => video.play(),
        // Removed onLeave to allow continuous play
      
        // Removed onLeaveBack to allow continuous play
      });
   

});
    function ensureVideoLoopOnMobile() {
      const videos = document.querySelectorAll('.slideshow__media video');
      videos.forEach(video => {
        video.loop = true; // Ensure video loops
        video.muted = true; // Mute the video to allow autoplay on mobile
        // Try to play the video
        video.play().catch(error => {
          console.warn("Video play failed on initial attempt:", error);
        });
        video.play();
        // For mobile devices, manually handling play might not be needed due to autoplay policy, hence no ScrollTrigger here
      });
    }

    
window.addEventListener('resize', updateContentMinHeight);



    gsap.utils.toArray(".tabbed-reviews").forEach(section => {
        let trigger = ScrollTrigger.create({
            trigger: section,
            start: "top top",
            end: () => `+=${section.offsetHeight}`,
            onEnter: () => {
                gsap.to(window, {
                    
                });
            },
            onLeave: () => {
                trigger.disable(); // Optional: Disable this trigger after leaving the section to allow normal scroll behavior
            },
            onEnterBack: () => {
                gsap.to(window, {
                   
                });
            },
            onLeaveBack: () => {
                trigger.disable(); // Optional: Disable this trigger after leaving the section to allow normal scroll behavior
            },
            // Remove pinning but keep the trigger for scroll actions
            pin: false,
            pinSpacing: false,
            scrub: 1
        });
    });

  // Function to update min-height of content areas
  function updateContentMinHeight() {
    let maxHeight = 20;
    document.querySelectorAll('.product .accordion__content').forEach(function(content) {
      const displayStatus = content.style.display; // Store current display status
      
      content.style.display = 'none'; // Temporarily show content to measure height
      maxHeight = Math.max(maxHeight, content.offsetHeight); // Update maxHeight if this content is taller
      content.style.display = displayStatus; // Revert to original display status
    });
    
    // Apply the maxHeight as min-height to all content areas
    document.querySelectorAll('.product .accordion__content').forEach(function(content) {
      content.style.minHeight = 0;
    });
  }
  });
  
  function pauseVideo(video) {
    if (video) video.pause();
      }
  
 





document.addEventListener('DOMContentLoaded', function() {
  const muteButtons = document.querySelectorAll('.multicolumn .mute-button');

  muteButtons.forEach(function(button) {
      button.addEventListener('click', function() {
          const currentVideo = this.parentNode.querySelector('.multicolumn video');
          const allVideos = document.querySelectorAll('.multicolumn video');

          // Toggle the current video's mute state
          if (currentVideo.muted) {
              // Unmute and play the current video
              currentVideo.muted = false;
              currentVideo.currentTime = 0; // Optionally restart the video from the beginning
              currentVideo.play();

              // Mute and pause all other videos
              allVideos.forEach(function(video) {
                  if (video !== currentVideo) {
                      video.muted = true; // Ensure other videos are muted
                      video.pause(); // Pause other videos
                  }
              });
          } else {
              // Mute the current video and let it continue playing
              currentVideo.muted = true;

              // Start playing all videos again, but muted
              allVideos.forEach(function(video) {
                  video.muted = true;
                  video.play(); // This line ensures that all videos start playing (muted)
              });
          }

          // Update icons for the current button
          const iconMute = this.querySelector('.icon-mute');
          const iconSound = this.querySelector('.icon-sound');
          iconMute.style.display = currentVideo.muted ? 'block' : 'none';
          iconSound.style.display = currentVideo.muted ? 'none' : 'block';
      });
  });
});

   


    function createRipple(event) {
      const button = event.currentTarget;
    
      // Check for an existing ripple
      const existingRipple = button.querySelector(".ripple");
      if (existingRipple) {
        existingRipple.remove(); // Ensures only one ripple effect is present at a time
      }
    
      // Create and append the ripple
      const ripple = document.createElement("span");
      ripple.classList.add("ripple");
      button.appendChild(ripple);
    
      // Calculate ripple position
      const buttonRect = button.getBoundingClientRect();
      const x = event.clientX - buttonRect.left;
      const y = event.clientY - buttonRect.top;
      ripple.style.left = x + "px";
      ripple.style.top = y + "px";
    
      // Initial ripple setup with GSAP
      gsap.set(ripple, {
        zIndex: -1,
        scale: 0,
        xPercent: -50,
        yPercent: -50,
      });
    
      // Animate ripple
      gsap.to(ripple, {
        duration: 0.6,
        width: buttonRect.width * 2,
        height: buttonRect.width * 2,
        scale: 1,
        opacity: 0,
        ease: "power1.out",
        onComplete: () => {
          ripple.remove(); // Clean up after the animation completes
        },
      });
    }
    function createPulse(event) {
      const button = event.currentTarget;
    
      // Check for an existing pulse
      const existingPulse = button.querySelector(".pulse-line");
      if (existingPulse) {
        existingPulse.remove(); // Ensures only one pulse effect is present at a time
      }
    
      // Create and append the pulse line
      const pulseLine = document.createElement("span");
      pulseLine.classList.add("pulse-line");
      button.appendChild(pulseLine);
    
      // Set up the pulse line's initial position and size
      gsap.set(pulseLine, {
        left: 0,
        width: "100%", // or however thick you want the line to be
        height: "3px", // making the line span the full height of the button
        backgroundColor: "#f4f4f4", // Color of the pulse line, adjust as needed
        position: "absolute",
        top: 0,
        zIndex: -1
      });
    
      // Animate the pulse line
      gsap.fromTo(pulseLine, {
        scaleX: 0,
        transformOrigin: "left center"
      }, {
        duration: .5, // Duration of the pulse line travel across the button
        scaleX: 1,
        ease: "none",
        onComplete: () => {
          pulseLine.remove(); // Clean up after the animation completes
        },
      });
    }
    
 
    
    // Attach event listeners to all buttons matching the selector
    document.querySelectorAll(".button.button--primary").forEach(button => {
      button.addEventListener("click", createPulse);

    });

document.addEventListener('DOMContentLoaded', function() {
    function initializeSlider() {
        const slider = document.querySelector('.index .slider-mobile-icon');
        if (!slider) return; // Exit if slider is not found

        // Duplicate slider content to ensure seamless looping
        slider.innerHTML += slider.innerHTML;
        const sliderItems = gsap.utils.toArray('.index .slider-mobile-icon > li');
        if (sliderItems.length <= 0) return; // Exit if no slider items

        const originalItemsWidth = sliderItems.slice(0, sliderItems.length / 2).reduce((acc, curr) => acc + curr.offsetWidth, 0);

        // Use GSAP's modifiers plugin for seamless looping
        gsap.to(sliderItems, {
            x: `-=${originalItemsWidth}`,
            duration: originalItemsWidth / 100,
            ease: "linear",
            modifiers: {
                x: gsap.utils.unitize(x => parseFloat(x) % originalItemsWidth)
            },
            repeat: -1,
            onStart: function() {
                console.log('Slide start');
            },
            onComplete: function() {
                console.log('Slide end');
                this.invalidate().restart(); // Restart the animation to create an infinite loop
            }
        });

        // Function to toggle slider autoplay based on screen width
        function updateSliderAutoplay() {
            if (window.innerWidth <= 749) {
                gsap.resumeAll(); // Resume autoplay if screen width is small
            } else {
                gsap.pauseAll(); // Pause autoplay if screen width is large
            }
        }

        updateSliderAutoplay(); // Initial check
        window.addEventListener('resize', updateSliderAutoplay); // Responsive adjustment
    }

    // Condition to check if the screen width is <= 749 pixels before initializing the slider
    if (window.innerWidth <= 749) {
        initializeSlider();
    }

    // Additionally, listen for window resize to initialize or pause autoplay based on new conditions
    window.addEventListener('resize', function() {
        if (window.innerWidth <= 749) {
            initializeSlider();
        } else {
            gsap.pauseAll(); // Pause autoplay if screen width is large
        }
    });
});
